import {Component} from 'react';
import h from 'react-hyperscript';
import './Cards.scss';
import Sidebar from 'Components/Cards/Sidebar/Sidebar';

class CardWithSidebar extends Component {
  constructor(props) {
    super(props);
    this.attributes = {
      id: null,
      className: 'card card--has-sidebar',
    };

    if (props.id) {
      this.attributes['id'] = props.id;
    }

    if (props.className) {
      this.attributes['className'] =
        this.attributes.className.concat(` ${props.className}`);
    }
  }

  render() {
    return (
      h('div', this.attributes, [
        h(Sidebar, {
          key: 'card-sidebar__key',
          activeStep: this.props.activeStep,
          onClick: this.props.goToStep,
          elementComplete: this.props.elementComplete,
          completedSteps: this.props.completedSteps,
          totalPercentComplete: this.props.totalPercentComplete,
          sidebarItems: this.props.sidebarItems,
          showRemaining: this.props.showRemaining,
          fieldValues: this.props.fieldValues,
        }),
        h('div', {
          key: 'card-main__key',
          className: 'card-main',
        }, this.props.children),
      ])
    );
  }
}

export default CardWithSidebar;
